import * as React from "react";

export const MaterialRectangleSvg = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={36} height={36} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M31 2H5a3 3 0 0 0-3 3v26a3 3 0 0 0 3 3h26a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Z"
        fill="#F8F1E8"
        stroke="#E6CCA1"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
